export default "__VITE_ASSET__BAUR7Mck__"